import LoadAssets from "./LoadAssets";

export default LoadAssets;